import React, { Component } from 'react'
import { Cascader } from 'antd'
import CommonTree from '../models/commonTree'

interface iProps {
    defaultValue?: string[];
    value?: string[];
    options: CommonTree[],
    onChange?: (value: string[]) => void;
}

export default class MultipleLevelCascader extends Component<iProps> {
  handleChange = (value: string[]) => {
    this.props.onChange(value);
  };
  format(selectorList: CommonTree[]) {
    let list = selectorList && selectorList.map((parentItem: CommonTree) => {
      let children = []
      if (parentItem.subNodes && parentItem.subNodes.length) {
        children = parentItem.subNodes && parentItem.subNodes.map((item: CommonTree) => {
          return {
            value: item.id,
            label: item.name,
            children: this.format(item.subNodes)
          };
        });
      } else {
        children = []
      }
      return {
        value: parentItem.id,
        label: parentItem.name,
        children
      };
    });
    return list;
  }
  render() {
      let { defaultValue = [],value, options } = this.props;
      return (
          <Cascader
            value={value}
            defaultValue={defaultValue}
            options={this.format(options)}
            changeOnSelect
            expandTrigger="hover"
            onChange={this.handleChange}
          />
      )
  }
}
